import { useEffect } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useFriends } from "@/hooks/useFriends";
import { FriendsTab } from "@/components/friends/FriendsTab";
import { RequestsTab } from "@/components/friends/RequestsTab";
import { SearchTab } from "@/components/friends/SearchTab";
import { InviteTab } from "@/components/friends/InviteTab";
import { ManagedTimelinesTab } from "@/components/friends/ManagedTimelinesTab";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";

export const FriendsDesktopNav = () => {
  const { friends, pendingRequests, loading } = useFriends();
  const { t } = useTranslation('friends');
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'friends';
  const fromInvite = searchParams.get('from') === 'invite';

  // Show welcome message if coming from invite
  useEffect(() => {
    if (fromInvite && defaultTab === 'requests') {
      toast.success('Welcome! Here are your pending friend requests from invitations.');
    }
  }, [fromInvite, defaultTab]);
  
  return (
    <Tabs defaultValue={defaultTab}>
      <TabsList className="grid w-full grid-cols-5 mb-6">
        <TabsTrigger value="friends">
          {t('tabs.friends')} ({loading ? t('loading') : friends.length})
        </TabsTrigger>
        <TabsTrigger value="requests">
          {t('tabs.requests')} ({loading ? t('loading') : pendingRequests.length})
        </TabsTrigger>
        <TabsTrigger value="search">
          {t('tabs.search')}
        </TabsTrigger>
        <TabsTrigger value="invite">{t('tabs.invite')}</TabsTrigger>
        <TabsTrigger value="managed">Managed Timelines</TabsTrigger>
      </TabsList>
      
      <TabsContent value="friends">
        <FriendsTab />
      </TabsContent>
      
      <TabsContent value="requests">
        <RequestsTab />
      </TabsContent>

      <TabsContent value="search">
        <SearchTab />
      </TabsContent>
      
      <TabsContent value="invite">
        <InviteTab />
      </TabsContent>
      
      <TabsContent value="managed">
        <ManagedTimelinesTab />
      </TabsContent>
    </Tabs>
  );
};